import cx from 'classnames'
import React from 'react'

import { Location as Icon } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './location.module.css'

import * as skeletonStyles from '../../skeleton.module.css'

const { font } = tokens.customProperties

const LocationComponent: React.FC<{ isPending?: boolean; className?: string }> = ({
  children,
  isPending,
  className = '',
}) => {
  return (
    <div className={cx(styles.component, className)} data-testid="location-icon">
      <SVG
        children={Icon}
        size={font.size.m}
        className={cx({ [styles.loading]: isPending })}
        hasGradient={!isPending}
      />
      <div className={cx(styles.label, skeletonStyles.base, { [skeletonStyles.active]: isPending })}>
        {isPending ? 'Fetching Location...' : children}
      </div>
    </div>
  )
}

export default LocationComponent
